"use strict";
(function (global) {
    // deklaracja klasy
    class CookiesSettingsManager {
        constructor(config) {
            //deklaracje zmiennych prywatnych
            this.settingsIdentifier = null;
            this.settings = {};

            this.init(config);
        }

        //funkcje publiczne
        init(config) {
            this.settingsIdentifier = config.id;

            if (!this.settingsIdentifier) {
                throw new Error("Please set id in constructor.");
            }

        }

        /**
         * @param successCallback
         * @param failureCallback
         */
        load(successCallback, failureCallback) {
            this.settings = {};

            const fromCookie = Cookies.get(this.settingsIdentifier + "_cookie");

            if (fromCookie) {
                this.settings = JSON.parse(fromCookie);
            }

            successCallback.call(this);
        }

        save() {
            Cookies.set(this.settingsIdentifier + "_cookie", this.settings)
        }

        get(key, defaultValue) {
            let retVal = defaultValue ? defaultValue : null;

            if (this.settings[key] !== null) {
                retVal = this.settings[key];
            }

            return retVal;
        }

        set(key, value) {
            this.settings[key] = value;
        }
    }

    //wyeksportowanie klasy
    global.NS = global.NS || {};
    global.NS.Grid = global.NS.Grid || {};
    global.NS.Grid.CookiesSettingsManager = CookiesSettingsManager;
})(window);
